var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "transparent", attrs: { flat: "", height: "46" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticClass:
                    "px-5 subtitle-2 grey-500--text font-weight-bold",
                },
                [_vm._v("Seguridad de la API")]
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "px-5 py-3" },
            [
              _c(
                "v-list",
                { staticClass: "v-list-form-2 pa-0 transparent" },
                [
                  _c(
                    "v-list-item",
                    { staticClass: "pa-0" },
                    [
                      _c("v-list-item-title", [
                        _vm._v("ID de la organización"),
                      ]),
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "ml-2" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                color: "grey-background",
                                right: "",
                                transition: "scale-transition",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "font-weight-regular",
                                            attrs: {
                                              text: "",
                                              color: "grey-700",
                                              ripple: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toClipboard(
                                                  _vm.$store.state.auth.account
                                                    .acc_id
                                                )
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$store.state.auth.account
                                                .acc_id
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("span", { staticClass: "d-block px-3 py-2" }, [
                                _vm._v("Copiar"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-action",
                        { staticStyle: { "min-width": "100px" } },
                        [
                          _c("v-col", {
                            staticClass: "pa-0",
                            attrs: { cols: "2" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mt-5", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "transparent", attrs: { flat: "", height: "46" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticClass:
                    "px-5 subtitle-2 grey-500--text font-weight-bold",
                },
                [_vm._v("Seguridad de POS")]
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "px-5 py-4" },
            [
              !_vm.$helpers.hasPermission(["view_pos"])
                ? _c("PermissionDenied", { attrs: { isDetail: true } })
                : _c(
                    "v-list",
                    { staticClass: "v-list-form-2 pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pa-0" },
                        [
                          _c("v-list-item-title", [
                            _vm._v("Archivo de configuración"),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0",
                                  staticStyle: { "max-width": "550px" },
                                  attrs: { cols: "10" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { outlined: "" },
                                      on: { click: _vm.downloadFile },
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("mdi-download"),
                                      ]),
                                      _vm._v("Archivo de configuración"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-action",
                            { staticStyle: { "min-width": "100px" } },
                            [_c("v-col", { attrs: { cols: "2" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }